import type {RenderingEngine} from '@cornerstonejs/core';

let sharedRenderingEngine: RenderingEngine | undefined;
const SHARED_ENGINE_ID = 'healthid-shared-rendering-engine';

export async function initializeCornerstone(): Promise<RenderingEngine> {
  if (sharedRenderingEngine) {
    return sharedRenderingEngine;
  }

  if (globalThis.window === undefined) {
    throw new TypeError(
      'Cornerstone initialization requires a browser environment'
    );
  }

  const {init: coreInit, RenderingEngine} = await import('@cornerstonejs/core');
  coreInit();

  const {init: dicomImageLoaderInit} =
    await import('@cornerstonejs/dicom-image-loader');
  dicomImageLoaderInit({
    maxWebWorkers: getOptimalWorkerCount(),
  });

  const engine = new RenderingEngine(SHARED_ENGINE_ID);
  sharedRenderingEngine = engine;
  return engine;
}

function getOptimalWorkerCount(): number {
  const hardwareConcurrency = navigator.hardwareConcurrency || 1;
  return Math.min(Math.max(hardwareConcurrency, 1), 4);
}

export function getSharedRenderingEngine(): RenderingEngine | undefined {
  return sharedRenderingEngine;
}

export function isInitialized(): boolean {
  return sharedRenderingEngine !== undefined;
}

export function destroySharedRenderingEngine(): void {
  if (sharedRenderingEngine) {
    try {
      sharedRenderingEngine.destroy();
    } catch {
      // Silently handle any errors during destruction
    } finally {
      // Ensure we clear the reference even if destroy throws an error
      sharedRenderingEngine = undefined;
    }
  }
}
